import details from './details'
import geofence from './geofence'
import list from './list'
import enabledDrivers from './enabled-drivers'

let sharedMutations = []

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    details.state,
    geofence.state,
    list.state,
    enabledDrivers.state
  ),
  mutations: Object.assign(
    details.mutations,
    geofence.mutations,
    list.mutations,
    enabledDrivers.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/services/index.js